<div class="p-autocomplete-float-group interface-control__custom-input-autocomplete__container">
  <bfx-autoComplete
    #inputField
    [(ngModel)]="data.item"
    [label]="label | capitalize:true"
    [suggestions]="data.filteredItems"
    (completeMethod)="search($event)"
    [disabled]="disabled || locked"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    (onSelect)="onSelect($event)"
    dataKey="dataItem"
    field="label"
    [autoHighlight]="true"
    [skipSorting]="true"
    delay="4"
    [state]="data.state"
    [dropdown]="true"
    [style]="{'width':'100%'}"
    [minLength]="1"
    size="sm"
    appendTo="body"
    nativeDesktopDropdown="bfxAlgoType"
    target="bfxAlgoType"
    delay="4"
  >
    <ng-template let-dataItem pTemplate="item">
      <div
        class="ui-helper-clearfix"
        [ngClass]="{'bfx-autocomplete_dropdown-list_field': !dataItem.lastFavorite,
														'bfx-autocomplete_dropdown-list_last-favorite': dataItem.lastFavorite}"
      >
        <div>{{dataItem.label}}</div>
      </div>
    </ng-template>
  </bfx-autoComplete>
</div>
